module.exports = __webpack_public_path__ + "static/media/style.013b50e0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/style.scss
// module id = 796
// module chunks = 0